import React from 'react';
import styled, { keyframes } from 'styled-components';
// import ListAltIcon from '@material-ui/icons/ListAlt';

import ButtonRouterLink from 'components/basic/Button/ButtonRouterLink';
import MaterialSymbol from 'components/basic/icons/MaterialSymbol';
import WalletIcon from 'components/basic/icons/WalletIcon';
import RouterNavLink from 'components/basic/Link/RouterNavLink';
import {
  useIsMobileBuySellRoute,
  useIsDashboardRoute,
} from 'components/trading/dashboardDetect';
import VaultIconSvg from 'components/vaults/images/VaultIconSvg';
import UnlockWalletButton from 'components/wallet/UnlockWalletButton';
import { STAKING_ENABLED, VAULTS_ENABLED } from 'config/constants';
import { getDashboardUrl } from 'reduxState/markets/listed/listedMarketsUtils';
import { useSelector } from 'reduxState/store';

const Wrapper = styled.div<{ marginTop?: boolean }>`
  grid-area: bottom-menu;
  margin: 4px 4px 0 4px;
`;

const Grid = styled.div<{ $columnsCount: number }>`
  padding: 10px;
  display: grid;
  background: var(--black1b);
  grid-template-columns: repeat(${({ $columnsCount }) => $columnsCount}, 1fr);
  gap: 10px;
  margin: 0 0 1px;
  border-radius: 2px;
`;

const MainSection = styled.div`
  height: var(--mobileFooterHeight);
  /* border-top: 1px  solid var(--separator); */
  background: var(--black1b);
  border-radius: 2px;
  display: flex;
  justify-content: space-around;
  align-items: stretch;
`;

const blinkAnimation = keyframes`
  15% {
    background: var(--lightBlack);
  }
`;

const StyledLink = styled(RouterNavLink)`
  position: relative;
  flex: 1;
  padding: 14px 0 10px;
  text-decoration: none;
  text-align: center;
  cursor: pointer;
  color: var(--gray4c);

  &.active {
    color: var(--white);
    border-top: 1px solid transparent;
  }

  &:focus {
    animation: ${blinkAnimation} 1s ease-out;
  }
`;

const TopBorderPlaceholder = styled.span`
  .active > & {
    display: block;
    position: absolute;
    height: 1px;
    background: white;
    top: -1px;
    left: 4vw;
    right: 4vw;
  }
`;

/**
 * Fixed position footer mobile menu
 * with <div /> which will take real space under menu.
 */
function FooterMenuMobile() {
  const walletUnlocked = !!useSelector(state => state.wallet.walletAddress);
  const isDashboard = useIsDashboardRoute();
  const currentMarket = useSelector(state => state.markets.currentMarket);
  const isTradeRoute = useIsMobileBuySellRoute();
  const dashboardurl = getDashboardUrl('katanaEVMChain', currentMarket.pair);
  const dashboardBuySellUrl = `${dashboardurl}/mobile-trade`;

  return (
    <Wrapper>
      {isDashboard && !isTradeRoute ? (
        <Grid $columnsCount={walletUnlocked ? 2 : 3}>
          {!walletUnlocked && (
            <UnlockWalletButton bordered={false} inline={false}>
              Connect
            </UnlockWalletButton>
          )}
          <ButtonRouterLink color="success" bordered to={dashboardBuySellUrl}>
            Buy / Long
          </ButtonRouterLink>
          <ButtonRouterLink color="red" to={dashboardBuySellUrl} bordered>
            Sell / Short
          </ButtonRouterLink>
        </Grid>
      ) : null}
      <MainSection>
        <StyledLink to="/wallet/menu-mobile">
          <TopBorderPlaceholder />
          <WalletIcon size={24} />
          <br />
          Wallet
        </StyledLink>
        <StyledLink to="/" isActive={isDashboard}>
          <TopBorderPlaceholder />
          <MaterialSymbol icon="swap_horiz" />
          <br />
          Trade
        </StyledLink>
        {VAULTS_ENABLED && (
          <StyledLink to="/vaults">
            <TopBorderPlaceholder />
            <VaultIconSvg color="currentColor" size={16} marginTop="4px" />
            <div style={{ height: 5 }} />
            Vaults
          </StyledLink>
        )}
        {STAKING_ENABLED && (
          <StyledLink to="/staking">
            <TopBorderPlaceholder />
            <MaterialSymbol icon="android_cell_4_bar" rounded />
            <div style={{ height: 4 }} />
            Earn
          </StyledLink>
        )}
        <StyledLink to="/mobile-rewards-menu">
          <TopBorderPlaceholder />
          <MaterialSymbol icon="star" rounded />
          <br />
          Rewards
        </StyledLink>
        <StyledLink to="/mobile-more">
          <TopBorderPlaceholder />
          <MaterialSymbol icon="menu" />
          <br />
          More
        </StyledLink>
      </MainSection>
    </Wrapper>
  );
}

export default FooterMenuMobile;
